



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
 apiKey: "AIzaSyDhgQbVOlQjR6ZB_DUlYsCsdojlz-tghFw",
  authDomain: "mmcollege-ofpharmacy.firebaseapp.com",
  projectId: "mmcollege-ofpharmacy",
  storageBucket: "mmcollege-ofpharmacy.firebasestorage.app",
  messagingSenderId: "486893023250",
  appId: "1:486893023250:web:566a96906359209b0768cb",
  measurementId: "G-8K6C3Z6DCS"
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



